<!-- Billing Address Dialog Card -->
<div class="construct-shipment__card" [formGroup]="billingForm" style="max-width: 650px">
  <mat-card appearance="outlined">
    <!-- Card title -->
    <mat-card-title>
      {{ "app.misc.billingAddressTitle" | translate }}
    </mat-card-title>
    <mat-card-content>
      <div class="form">
        <!-- Row 1: Company & Person Name -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.companyName" | translate }}</mat-label>
            <input
              matInput
              required
              maxlength="100"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.companyName' | translate }}"
              formControlName="companyName"
              autocomplete="billing"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.personName" | translate }}</mat-label>
            <input
              matInput
              required
              autocomplete="billing"
              minlength="3"
              maxlength="100"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.personName' | translate }}"
              formControlName="personName"
            />
          </mat-form-field>
        </div>

        <!-- Row 2: Country Name (full width) -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>
              {{ "app.shopifyOrders.details.shipperConsigneeDetails.countryName" | translate }}
            </mat-label>
            <mat-select required formControlName="countryID" (selectionChange)="changeBillingCountryEvent()">
              @for (country of countriesList; track country) {
                <mat-option [value]="country.CON_ID">
                  {{ country.CON_Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Row 3: Phone & Extension -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate }}</mat-label>
            <input
              required
              matInput
              type="text"
              mask="{{ phoneMaskOrigin }}"
              autocomplete="billing"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate }}"
              formControlName="phone"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate }} Ext.</mat-label>
            <input
              matInput
              type="text"
              autocomplete="billing"
              maxlength="50"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate }} Ext."
              formControlName="extension"
            />
          </mat-form-field>
        </div>

        <!-- Row 4: Email & Residential -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.email" | translate }}</mat-label>
            <input
              matInput
              required
              autocomplete="billing"
              maxlength="200"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.email' | translate }}"
              formControlName="email"
            />
          </mat-form-field>
          <div class="form__checkbox-field">
            <mat-checkbox formControlName="isResidential" color="primary">
              {{ "app.shopifyOrders.details.isResidential" | translate }}
            </mat-checkbox>
          </div>
        </div>

        <!-- Row 5: Google Search box (full width) -->
        <mat-form-field class="full-width" [appearance]="appearance" style="width: 100%">
          <mat-label style="color: rgb(175, 149, 0)">
            {{ "app.misc.searchAddress" | translate }}
          </mat-label>
          <input
            ngx-google-places-autocomplete
            matInput
            placeholder="{{ 'app.misc.searchAddress' | translate }}"
            class="form-control"
            autocomplete="billing"
            (focus)="changeBillingCountryEvent()"
            onfocus="this.setAttribute('autocomplete', 'billing');"
            #billingSearchAddress
          />
        </mat-form-field>

        <!-- Row 6: Street & Unit -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.streetName" | translate }}</mat-label>
            <input
              matInput
              required
              autocomplete="billing"
              maxlength="100"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.streetName' | translate }}"
              formControlName="streetName"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.unit" | translate }}</mat-label>
            <input
              matInput
              maxlength="100"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.unit' | translate }}"
              autocomplete="billing"
              formControlName="unit"
            />
          </mat-form-field>
        </div>

        <!-- Row 7: City Name (full width) -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.cityName" | translate }}</mat-label>
            <input
              matInput
              required
              autocomplete="billing"
              maxlength="100"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.cityName' | translate }}"
              formControlName="cityName"
            />
          </mat-form-field>
        </div>

        <!-- Row 8: Postal code & State/Province -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.zipCode" | translate }}</mat-label>
            <input
              matInput
              required
              autocomplete="billing"
              maxlength="50"
              placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.zipCode' | translate }}"
              formControlName="zipCode"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>
              {{ "app.misc.state" | translate }}
            </mat-label>
            <mat-select matNativeControl formControlName="stateID" required>
              @for (state of billingFilteredStateProvinces; track state) {
                <mat-option [value]="state.PRV_ID">
                  {{ state.PRV_Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Row 9: Special Instructions & Tax ID -->
        <div class="form__row">
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>{{ "app.shopifyOrders.details.specialInstruction" | translate }} (1000c)</mat-label>
            <textarea
              matInput
              maxlength="1000"
              autocomplete="billing"
              placeholder="{{ 'app.shopifyOrders.details.specialInstruction' | translate }}"
              formControlName="specialInstruction"
            ></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form__field">
            <mat-label>Tax ID</mat-label>
            <input matInput maxlength="50" autocomplete="billing" formControlName="taxID" />
          </mat-form-field>
        </div>

        <!-- Buttons -->
        <div style="display: flex; align-items: center; gap: 16px; margin-top: 24px; justify-content: flex-end">
          <button mat-raised-button color="primary" [disabled]="!billingForm.valid" (click)="saveBillingAddress()">
            {{ "app.addressEditor.saveAddress" | translate }}
            <mat-icon class="material-icons"> save </mat-icon>
          </button>
          <button mat-raised-button color="warn" (click)="close()">
            {{ "app.misc.cancel" | translate }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
